import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66d7e671"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-and-payment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_3 = { class: "remarks-text" }
const _hoisted_4 = { class: "remarks" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_6 = { class: "deliverer-text" }
const _hoisted_7 = { class: "city" }
const _hoisted_8 = { class: "deliverer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_OrderSource = _resolveComponent("OrderSource")!
  const _component_OrderDetails = _resolveComponent("OrderDetails")!
  const _component_KitchenDetails = _resolveComponent("KitchenDetails")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-tile", { highlight: _ctx.highlight, delivered: _ctx.delivered, alert: _ctx.alert }]),
    onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args))),
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('mouseover'))),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('mouseleave'))),
    ref: "tile"
  }, [
    (!_ctx.order.has_seen)
      ? (_openBlock(), _createBlock(_component_IconBase, {
          key: 0,
          icon: "circle-filled",
          class: "not-seen-order animate-pulse-object"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_OrderSource, {
      order: _ctx.order,
      "show-remarks": _ctx.showRemarks,
      "show-deliverer": _ctx.showDeliverer
    }, null, 8, ["order", "show-remarks", "show-deliverer"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_OrderDetails, {
        isForMap: _ctx.isForMap,
        order: _ctx.order,
        "delivery-type": _ctx.deliveryType,
        showButtons: _ctx.showButtons,
        "show-remarks": _ctx.showRemarks,
        "show-deliverer": _ctx.showDeliverer
      }, null, 8, ["isForMap", "order", "delivery-type", "showButtons", "show-remarks", "show-deliverer"]),
      _createVNode(_component_KitchenDetails, {
        order: _ctx.order,
        "delivery-type": _ctx.deliveryType,
        showButtons: _ctx.showButtons,
        onStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateStatus($event))),
        "show-remarks": _ctx.showRemarks,
        "show-deliverer": _ctx.showDeliverer
      }, null, 8, ["order", "delivery-type", "showButtons", "show-remarks", "show-deliverer"]),
      (_ctx.showRemarks)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.order.remarks), 1)
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.showDeliverer)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.order.customer?.address?.city), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.order.deliverer?.first_name +
                            " " +
                            _ctx.order.deliverer?.last_name), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 34))
}